
import BackSquare from "../../../assets/outline/BackSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BackSquareIcon({ className, dataTestid = "BackSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BackSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
